import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpHandler,
    HttpRequest,
    HTTP_INTERCEPTORS,
    HttpEvent
} from '@angular/common/http';

import { Observable } from "rxjs";

import { DatabaseService } from '../database/database.service';
import { FsessionService } from '../session/fsession.service';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class IpInterceptor implements HttpInterceptor {

    private ipPublica = '';
    private nombreApp = '';

    constructor(
        private _databaseService: DatabaseService,
        private _fsessionService: FsessionService

    ) { }

    /**
     * Interceptor que agrega los headers 'user-ip' y 'resource-app' a las peticiones realizadas al servidor
     * @param req HttpRequest - solicitud o request recibida
     * @param next HttpHandler - manejador de la peticion
     * @returns Observable de tipo HttpEvent con la peticion modificada
     */
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        this.ipPublica = this._databaseService.IpPublica;

        if (req.url.includes(environment.servidor_api)) {
            const reqClone = req.clone({
                headers: req.headers.set('user-ip', this.ipPublica)
            });

            return next.handle(reqClone);
        }
        return next.handle(req);
    }

}

/**
 * Configuracion del interceptor
 */
export const IpinterceptorProvider = {
    provide: HTTP_INTERCEPTORS,
    useClass: IpInterceptor,
    multi: true
};